import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { get, post } from "../../services/api";

function NavFormList() {
  const token = localStorage.getItem("token");
  const [navFormData, setNavFormData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentNavForm, setCurrentNavForm] = useState({
    id: "",
    name: "",
  });

  const modalStyles = {
    display: "flex",
    position: "fixed",
    zIndex: 1000,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    justifyContent: "center",
    alignItems: "center",
  };

  const modalContentStyles = {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
    width: "400px",
    maxWidth: "90%",
  };

  const inputStyles = {
    margin: "10px 0",
    padding: "8px",
    width: "100%",
    boxSizing: "border-box",
  };

  const getCategories = async () => {
    if (!token) return;
    try {
      const response = await get("UserAuthentication/GetAllCategory", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCategoryData(response.navCategory);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const getSubCategoryList = async (categoryId) => {
    if (!token || !categoryId) return;
    try {
      const formdata = { formCategoryId: categoryId };
      const response = await post(
        `UserAuthentication/GetAllNavSubCategory`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setSubCategoryData(response);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const getNavFormList = async (subCategoryId) => {
    if (!token || !subCategoryId) return;
    try {
      const formdata = { formSubCategoriesId: subCategoryId };
      const response = await post(
        `UserAuthentication/GetAllNavForm`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setNavFormData(response);
    } catch (error) {
      console.error("Error fetching nav forms:", error);
    }
  };

  const handleEdit = async (id) => {
    const formdata = { id: id };
    try {
      const response = await post(
        `UserAuthentication/GetNavFormById`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCurrentNavForm(response);
      setIsEditMode(true);
      setModalOpen(true);
    } catch (error) {
      console.error("Error fetching nav form:", error);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this nav form?"
    );
    if (confirmDelete) {
      const formdata = { id: id };
      try {
        await post(`UserAuthentication/DeleteNavForm`, formdata, {
          headers: { Authorization: `Bearer ${token}` },
        });
        getNavFormList(selectedSubCategoryId); // Refresh the nav form list after deletion
      } catch (error) {
        console.error("Error deleting nav form:", error);
      }
    } else {
      console.log("Deletion canceled.");
    }
  };

  const handleCreate = () => {
    setCurrentNavForm({ id: "", name: "" });
    setIsEditMode(false);
    setModalOpen(true);
  };

  const handleSave = async () => {
    if (!currentNavForm.name.trim()) {
      alert("Nav form name is required.");
      return;
    }

    const saveId = currentNavForm.id ? currentNavForm.id : 0;
    const formdata = {
      id: saveId,
      name: currentNavForm.name,
      FormSubCategoriesId: selectedSubCategoryId,
    };
    try {
      await post(`UserAuthentication/AddUpdateNavForm`, formdata, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setModalOpen(false);
      getNavFormList(selectedSubCategoryId); // Refresh the nav form list after save
    } catch (error) {
      console.error("Error saving nav form:", error);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    if (selectedCategoryId) {
      getSubCategoryList(selectedCategoryId);
    } else {
      setSubCategoryData([]);
      setNavFormData([]);
    }
  }, [selectedCategoryId]);

  useEffect(() => {
    if (selectedSubCategoryId) {
      console.log(selectedSubCategoryId);
      getNavFormList(selectedSubCategoryId);
    } else {
      setNavFormData([]);
    }
  }, [selectedSubCategoryId]);

  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      omit: false,
    },
    {
      name: "Nav Form Name",
      selector: (row) => `${row.name}`,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div>
          <button
            className="btn btn-outline-primary py-1 px-2 lh-2"
            onClick={() => handleEdit(row.id)}
          >
            Edit
          </button>
          <button
            className="btn btn-outline-danger py-1 px-2 lh-2"
            onClick={() => handleDelete(row.id)}
          >
            Delete
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <>
      <div className="col-md-12">
        <div className="row">
          <div className="col-md-3">
            <label htmlFor="categorySelect">Select Category:</label>
            <select
              id="categorySelect"
              value={selectedCategoryId}
              className="form-control"
              onChange={(e) => setSelectedCategoryId(e.target.value)}
            >
              <option value="">--Select Category--</option>
              {categoryData.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label htmlFor="subCategorySelect">Select Subcategory:</label>
            <select
              id="subCategorySelect"
              value={selectedSubCategoryId}
              className="form-control"
              onChange={(e) => setSelectedSubCategoryId(e.target.value)}
            >
              <option value="">--Select Subcategory--</option>
              {subCategoryData.map((subCategory) => (
                <option key={subCategory.id} value={subCategory.id}>
                  {subCategory.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <button className="btn btn-outline-primary" onClick={handleCreate}>
        Create Nav Form
      </button>

      {selectedSubCategoryId ? (
        <DataTable columns={columns} data={navFormData} pagination dense />
      ) : (
        <div className="text-center mt-3">
          <p>
            No records found. Please select a subcategory to view nav forms.
          </p>
        </div>
      )}

      {modalOpen && (
        <div className="modal" style={modalStyles}>
          <div className="modal-content" style={modalContentStyles}>
            <h2>{isEditMode ? "Edit Nav Form" : "Create Nav Form"}</h2>
            <div>
              <label>ID:</label>
              <input
                type="text"
                value={currentNavForm.id}
                readOnly
                style={inputStyles}
              />
            </div>
            <div>
              <label>Name:</label>
              <input
                type="text"
                value={currentNavForm.name}
                onChange={(e) =>
                  setCurrentNavForm({
                    ...currentNavForm,
                    name: e.target.value,
                  })
                }
                style={inputStyles}
              />
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={handleSave}
                className="btn btn-outline-success"
                style={{ marginRight: "10px" }}
              >
                Save
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="btn btn-outline-secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default NavFormList;
